module.exports = __webpack_public_path__ + "static/media/list.aba2d4fb.svg";